import { Badge, BadgeColor } from "@prequel/shared-components";

export enum DataIntegrityStatus {
  HEALTHY = "HEALTHY",
  UNHEALTHY = "UNHEALTHY",
  UNKNOWN = "UNKNOWN",
}

export const getDataIntegrityStatusBadgeColor = (status: DataIntegrityStatus): BadgeColor => {
  switch (status) {
    case DataIntegrityStatus.UNHEALTHY:
      return BadgeColor.RED;
    case DataIntegrityStatus.HEALTHY:
      return BadgeColor.GREEN;
    case DataIntegrityStatus.UNKNOWN:
    default:
      return BadgeColor.GRAY;
  }
};

export const isDataIntegrityStatusBadgeActive = (status: DataIntegrityStatus): boolean => {
  return [DataIntegrityStatus.HEALTHY, DataIntegrityStatus.UNHEALTHY].includes(status);
};

interface DataIntegrityStatusBadgeProps {
  status: DataIntegrityStatus;
  color: BadgeColor;
  isActive: boolean;
}

const DataIntegrityStatusBadge = ({ status, color, isActive }: DataIntegrityStatusBadgeProps) => {
  return <Badge className="normal-case" color={color} active={isActive} text={status} />;
};

export default DataIntegrityStatusBadge;
